import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when the "Select Dates" step of the NEW Shift Request form is viewed
 * Event: dental_portal:shift_request:select_dates_viewed
 */
export function fireSelectDatesPageViewed(): void {
  PosthogService.getInstance().track('dental_portal:shift_request:select_dates_viewed');
}
